module.exports = __webpack_public_path__ + "img/fi-rr-e-learning.ca85423b.svg";